import React, { useState } from 'react'
import './CSS/LoginSignup.css'
import { Link } from 'react-router';
import ForgotPassword from './ForgotPassword';


  const LoginSignup = () => {

    const [state, setState] = useState("Bejelentkezés");

    const [formData,setFormData] = useState({
      username:"",
      password:"",
      email:""
    })

    const [error, setError] = useState(""); 

    const changeHandler = (e) => {
      setFormData({...formData,[e.target.name]:e.target.value});
      setError("");
    }

    const login = async ()=>{
      console.log("asd", formData);
      let responseData;
      await fetch('/api/login',{
        method:'POST',
        headers:{
          Accept:'application/form-data',
          'Content-Type':'application/json',
        },
        body:JSON.stringify(formData),
      }).then((response)=>response.json()).then((data)=>responseData=data)

      if(responseData.success){
        localStorage.setItem('auth-token',responseData.token);
        window.location.replace("/");
      }
      else{
        setError(responseData.errors)
      }
      
    }

    const signup = async ()=>{
      
      console.log("signuo", formData);
      let responseData;
      await fetch('/api/signup',{
        method:'POST',
        headers:{
          Accept:'application/form-data',
          'Content-Type':'application/json',
        },
        body:JSON.stringify(formData),
      }).then((response)=>response.json()).then((data)=>responseData=data)

      if(responseData.success){
        localStorage.setItem('auth-token',responseData.token);
        window.location.replace("/");
      }
      else{
        setError(responseData.errors)
      }
    }


    return (
        <div className='loginsignup'>
          <div className="loginsignup-container">
            <h1>{state}</h1>
            <div className="loginsignup-fields">
              {state==="Regisztráció"?<input name='username' value={formData.username} onChange={changeHandler} type="text" placeholder='Név' />:<></>}
              <input name='email' value={formData.email} onChange={changeHandler} type="email" placeholder='Email cím' />
              <input name='password' value={formData.password} onChange={changeHandler} type="password" placeholder='Jelszó' />
            </div>
            {error && <p className="loginsignup-error" style={{color:"red"}}>{error}</p>}
            <button onClick={()=>{state==="Bejelentkezés"?login():signup()}}>Folytatás</button>
            {state==="Regisztráció"?<p className='loginsignup-login'>Már van fiókod? <span onClick={()=>{setState("Bejelentkezés")}}>Bejelentkezés</span></p>:<p className='loginsignup-login'>Regisztrációhoz <span onClick={()=>{setState("Regisztráció")}}>Kattints ide</span></p>}
            {state==="Bejelentkezés"?(<Link to='/forgot-password'><button>Elfelejtett jelszó</button></Link>):<></>}
            
            {state==="Regisztráció"?<div className="loginsignup-agree">
              <p>A folytatás megnyomásával elfogadod az általános szerződési feltételeket</p>
            </div>:<></>}
          </div>
    
        </div>
      )
  }


export default LoginSignup